import React from 'react';
import PropTypes from 'prop-types';
import SvgSprite from '../../atoms/svg-sprite/SvgSprite.jsx';

const CategoryTeaser = ({ href, headline, text }) => (
  <a
    href={href}
    title={headline}
    className="m-category-teaser o-teaser-container-categories__teaser has-hoverable-children"
  >
    <span className="a-headline a-headline--highlight a-headline--with-deco m-category-teaser__headline">
      {headline}
    </span>

    {text && <p className="a-copy a-copy--focused m-category-teaser__copy">{text}</p>}

    <div className="m-category-teaser__icon">
      <SvgSprite id="default-arrow" title="Arrow" />
    </div>
  </a>
);

CategoryTeaser.propTypes = {
  href: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  text: PropTypes.string
};

CategoryTeaser.defaultProps = {
  text: ''
};

export default CategoryTeaser;
